import React, {useEffect, useState} from 'react';
import Input from "../../UI/Input";
import SingleDay from "../../UI/SingleDay";
import DateTime from "../../UI/DateTime";
import Select from "../../UI/Select";
import {Button} from "@mui/material";
import close from '../../image/close.png'
import {BX24} from "../../hooks/BX24";

const ModalAddTask = ({setValue}) => {

    const taskDefault = {
        title: {
            value: '',
            error: ''
        },
        address: {
            value: '',
            error: ''
        },
        phone: {
            value: '',
            error: ''
        },
        date: {
            value: '',
            error: ''
        },
        time: {
            value: '',
            error: ''
        },
        cost: {
            value: '',
            error: ''
        },
        comment: {
            value: '',
            error: ''
        },
        user: {
            value: '',
            error: ''
        },
        name: {
            value: '',
            error: ''
        }
    }
    const [taskValues, setTaskValues] = useState(taskDefault)

    useEffect(() => {
        console.log(taskValues)
    }, [taskValues])

    const createTask = async () => {
        if(taskValues.title.value.length < 2)
            return setTaskValues({...taskValues, title: {...taskValues.title, error: 'Заполните это поле'}})

        if(taskValues.address.value.length < 2)
            return setTaskValues({...taskValues, address: {...taskValues.address, error: 'Заполните это поле'}})

        if(taskValues.cost.value === '')
            return setTaskValues({...taskValues, cost: {...taskValues.cost, error: 'Заполните это поле'}})

        if(taskValues.date.value === '' || taskValues.date.value.length < 2)
            return setTaskValues({...taskValues, date: {...taskValues.date, error: 'Заполните это поле'}})

        if(taskValues.phone.value === '' || taskValues.phone.value.length < 2)
            return setTaskValues({...taskValues, phone: {...taskValues.phone, error: 'Заполните это поле'}})

        if(taskValues.user.value === '' || taskValues.user.value.length < 2)
            return setTaskValues({...taskValues, user: {...taskValues.user, error: 'Заполните это поле'}})

        if(taskValues.name.value === '' || taskValues.name.value.length < 2)
            return setTaskValues({...taskValues, name: {...taskValues.name, error: 'Заполните это поле'}})

        const time = new Date(`2022-01-01T${taskValues.time.value}`); // создаем объект Date с заданным временем
        time.setHours(time.getHours()); // вычитаем 4 часа из часового значения

        const data_time = time.toLocaleTimeString()

        const fields = {
            NAME: taskValues.title.value,
            PROPERTY_326: `user_${taskValues.user.value}`,
            PROPERTY_332: taskValues.phone.value,
            PROPERTY_334: taskValues.comment.value,
            PROPERTY_338: `${taskValues.date.value} ${data_time}`,
            PROPERTY_356: parseInt(taskValues.cost.value),
            PROPERTY_328: `${taskValues.date.value} ${data_time}`,
            PROPERTY_340: taskValues.name.value,
            PROPERTY_330: taskValues.address.value
        }

        let data = {
            'IBLOCK_TYPE_ID': 'lists',
            'IBLOCK_ID': '60',
            'ELEMENT_ID': '2',
            'FIELDS': fields
        };

        await BX24('lists.element.add', data)

        const fields2 = {
            'NAME' : taskValues.title.value,
            'PROPERTY_360' : taskValues.user.value,
            'PROPERTY_350' : `${taskValues.date.value} ${taskValues.time.value}`,
            'PROPERTY_352' : parseInt(taskValues.cost.value)
        }

        data = {
            'IBLOCK_TYPE_ID': 'lists',
            'IBLOCK_ID': '62',
            'ELEMENT_ID': '2',
            'FIELDS': fields2
        };

        await BX24('lists.element.add', data)

        alert('Замер успешно назначен')
        setValue(false)
    }

    return (
        <div className={'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white border z-20 w-2/3'}>
            <div className={'p-4 flex justify-between flex-wrap'}>
                <div className={'w-full'}>
                    <div onClick={() => setValue(false)} className={'w-12 ml-auto cursor-pointer'}>
                        <img className={'w-full'} src={close} alt=""/>
                    </div>
                </div>
                <div className={'w-72 mt-8'}>
                    <Input
                        value={taskValues.title.value}
                        onChange={e => setTaskValues({...taskValues, title: {...taskValues.title, value: e.target.value}})}
                        error={taskValues.title.error && true}
                        label={'Заголовок'}
                        sx={{width: '100%'}}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <Input
                        value={taskValues.address.value}
                        onChange={e => setTaskValues({...taskValues, address: {...taskValues.address, value: e.target.value}})}
                        error={taskValues.address.error && true}
                        label={'Адрес'}
                        sx={{width: '100%'}}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <Input
                        value={taskValues.phone.value}
                        onChange={e => setTaskValues({...taskValues, phone: {...taskValues.phone, value: e.target.value}})}
                        label={'Телефон'}
                        sx={{width: '100%'}}
                        error={taskValues.phone.error && true}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <Input
                        value={taskValues.name.value}
                        onChange={e => setTaskValues({...taskValues, name: {...taskValues.name, value: e.target.value}})}
                        label={'Имя клиента'}
                        sx={{width: '100%'}}
                        error={taskValues.name.error && true}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <Input
                        value={taskValues.cost.value}
                        onChange={e => setTaskValues({...taskValues, cost: {...taskValues.cost, value: parseInt(e.target.value)}})}
                        label={'Стоимость выезда'}
                        sx={{width: '100%'}}
                        error={taskValues.cost.error && true}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <SingleDay
                        value={taskValues.date.value}
                        onChange={e => setTaskValues({...taskValues, date: {...taskValues.time, value: e.target.value}})}
                        error={taskValues.date.error && true}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <DateTime
                        onChange={e => setTaskValues({...taskValues, time: {...taskValues.time, value: e.target.value}})}
                        error={taskValues.time.error && true}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <Input
                        value={taskValues.comment.value}
                        onChange={e => setTaskValues({...taskValues, comment: {...taskValues.comment, value: e.target.value}})}
                        label={'Комментарий'}
                        sx={{width: '100%'}}
                        multiline
                        error={taskValues.comment.error && true}
                        rows={4}
                    />
                </div>

                <div className={'w-72 mt-8'}>
                    <Select
                        value={taskValues.user.value}
                        onChange={e => setTaskValues({...taskValues, user: {...taskValues.user, value: e.target.value}})}
                        label={'Исполнитель'}
                        sx={{width: '100%'}}
                        helperText="Выберите исполнителя"
                        error={taskValues.user.error && true}
                    />
                </div>

                <div className={'w-72 mt-8'} onClick={() => createTask()}>
                    <Button color={'primary'} variant={'contained'}>Создать</Button>
                </div>
            </div>
        </div>
    );
};

export default ModalAddTask;